import React, { useMemo } from "react";
import { useLocation } from "react-router";
import TableauEmbed from "../components/TableauEmbed";
import {
  TABLEAU_RS,
  TABLEAU_SCO,
  TABLEAU_P4P_RS,
  TABLEAU_P4P_SCO,
} from "../Config/Tableau";
import { Constants } from "../constants/appConstants";

type TableauNavigationState = {
  portal?: string;
  providerType?: string;
};

const normalizeProviderType = (value?: string): string => {
  const normalized = String(value || "").trim().toUpperCase();

  if (normalized === Constants.SCOKey) {
    return Constants.SCOKey;
  }

  if (
    normalized === Constants.RSKey ||
    normalized === "RESIDENTIAL" ||
    normalized === "RH"
  ) {
    return Constants.RSKey;
  }

  return Constants.RSKey;
};

const TableauDashboardPage: React.FC = () => {
  const location = useLocation();
  const state = (location.state as TableauNavigationState | null) ?? null;

  const portal = state?.portal ?? Constants.PBC_RS_TABLEAU_URL_KEY;
  const providerType = normalizeProviderType(state?.providerType);

  const tableauConfig = useMemo(() => {
    if (portal === Constants.P4P_TABLEAU_URL_KEY) {
      return providerType === Constants.SCOKey
        ? TABLEAU_P4P_SCO
        : TABLEAU_P4P_RS;
    }

    if (portal === Constants.PBC_TABLEAU_URL_KEY) {
      return TABLEAU_SCO;
    }

    if (portal === Constants.PBC_RS_TABLEAU_URL_KEY) {
      return TABLEAU_RS;
    }

    return providerType === Constants.SCOKey
      ? TABLEAU_SCO
      : TABLEAU_RS;
  }, [portal, providerType]);

  return (
    <div style={{ padding: 16 }}>
      <div
        style={{
          border: "1px solid #ddd",
          borderRadius: 8,
          overflow: "hidden",
        }}
      >
        <TableauEmbed
          workbook={tableauConfig.workbook}
          view={tableauConfig.view}
          height={tableauConfig.height}
        />
      </div>
    </div>
  );
};

export default TableauDashboardPage;